var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CustomizationOfferCreateAdmin',{attrs:{"CO":_vm.CO,"orderData":_vm.orderData},on:{"save":function($event){return _vm.save()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }